/**
 * Per-entity Smart Copy descriptor for Indicators — the single source of truth
 * for the Indicator tab's tooltip wording. Mirrors `controlTestSmartCopy.ts`.
 *
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); 'Indicator'
 *   reproduces the deployed sister-convention (Control Test) event strings.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase).
 */
export const INDICATOR_SMART_COPY = {
  eventLabel: 'Indicator',
  entityNoun: 'indicator',
} as const;
